import type { ReactElement } from 'react';

import Title from '@/components/atoms/Title';

import { SectionWrap } from '../SectionWrap/SectionWrap';
import {
  WhyEmoji,
  WhyGrid,
  WhyItem,
  WhyItemDescription,
  WhyItemTitle,
} from './Why.styled';

interface WhyReason {
  description: string;
  emoji: string;
  id: number;
  title: string;
}

const reasons: WhyReason[] = [
  {
    id: 1,
    emoji: '🏖️',
    title: 'Raj dla plażowiczów',
    description:
      'Nawet 300 słonecznych dni w roku i doskonałe warunki do kąpieli, które panują tu przez cały czas, zachęcają do podróży również poza sezonem.',
  },
  {
    id: 2,
    emoji: '🎢',
    title: 'Mnóstwo atrakcji',
    description:
      'Muzea, aquaparki i wulkany, lasy laurowe i rejsy z delfinami. Ogrody, wodospady i trasy z widokami, a dla chętnych nawet jazda quadami. Tutaj nie da się nudzić!.',
  },
  {
    id: 3,
    emoji: '🌋',
    title: 'Różnorodność',
    description:
      'Marsjańskie krajobrazy, gorące plaże i kaktusy, a z drugiej strony ośnieżony szczyt, chłodne wąwozy i wilgotne lasy. Teneryfa to wyspa pełna zjawiskowych kontrastów.',
  },
  {
    id: 4,
    emoji: '🛫',
    title: 'Dostępność',
    description:
      'Bezpośrednie loty z Polski, dobra komunikacja na miejscu i wielkość wyspy, pozwalająca na swobodne przemieszczanie się pomiędzy atrakcjami, uławiają podróżowanie.',
  },
  {
    id: 5,
    emoji: '🤩',
    title: 'Dla każdego',
    description:
      'Obojętnie, czy lubisz leżeć na plaży, czy wolisz aktywnie spędzać czas, podróżujesz solo, z dziećmi, psem, wolisz imprezy albo spokój i ciszę, tutaj znajdziesz coś dla siebie.',
  },
  {
    id: 6,
    emoji: '💰',
    title: 'Budżetowo',
    description:
      'Na Teneryfie jest taniej niż w kontynentalnej Hiszpanii i innych krajach europejskich. Loty i noclegi można znaleźć w bardzo dobrych cenach, więc jest to opcja na wakacje, które nie rujnują portfela.',
  },
];

const Why = (): ReactElement => (
  <SectionWrap>
    <Title>Dlaczego Teneryfa?</Title>
    <WhyGrid>
      {reasons.map(reason => (
        <WhyItem key={reason.id}>
          <WhyEmoji>{reason.emoji}</WhyEmoji>
          <WhyItemTitle>{reason.title}</WhyItemTitle>
          <WhyItemDescription>{reason.description}</WhyItemDescription>
        </WhyItem>
      ))}
    </WhyGrid>
  </SectionWrap>
);

export default Why;
